const stateTypes = {
  specificationSelections: 'specificationSelections',
  unitsWithSpecification: 'unitsWithSpecification',
  currentlyEditedSpecification: 'currentlyEditedSpecification'
};

const getterTypes = {
  SpecificationApi: 'SpecificationApiGetter',
  getAllUnitsWithSpecification: 'getAllUnitsWithSpecificationGetter',
  getSpecificationSelections: 'getSpecificationSelectionsGetter',
  getCurrentlyEditedSpecification: 'getCurrentlyEditedSpecificationGetter'
};

const mutationTypes = {
  saveSpecification: 'saveSpecificationMutation',
  addSpecificationSelections: 'addSpecificationSelectionsMutation',
  setAllUnitsWithSpecifications: 'setAllUnitsWithSpecificationsMutation',
  deleteSpecification: 'deleteSpecificationMutation',
  setSingleSpecification: 'setSingleSpecificationMutation'
};

const actionTypes = {
  saveSpecification: 'saveSpecificationAction',
  getAllSpecificationSelections: 'getAllSpecificationSelectionsAction',
  getAllUnitsWithSpecification: 'getAllUnitsWithSpecificationAction',
  assignSpecification: 'assignSpecificationAction',
  deleteSpecification: 'deleteSpecificationAction',
  getSingleSpecification: 'getSingleSpecificationAction',
  updateSpecification: 'updateSpecificationAction',
  editSpecification: 'editSpecificationAction',
  unassignSpecification: 'unassignSpecificationAction'
};

export { stateTypes, getterTypes, mutationTypes, actionTypes };
